import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NotaFiscalEdicao } from '@/features/nfe/page/edicao/NotaFiscalEdicao';
import { NotaFiscalProntaEntregaTipoSchema } from '@/models/nota-fiscal/types';

export const Route = createFileRoute('/a/nota-fiscal/cadastrar')({
    component: Component,
    validateSearch: z.object({
        vendaExterna: z
            .object({
                idpk: z.number(),
                tipo: NotaFiscalProntaEntregaTipoSchema,
            })
            .optional(),
    }),
});

function Component() {
    const { vendaExterna } = Route.useSearch();

    return <NotaFiscalEdicao action='cadastrar' vendaExterna={vendaExterna} />;
}
